import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./header.css";

const Header = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    // Check user data on component mount and when localStorage changes
    const checkUser = () => {
      const userData = localStorage.getItem("user");
      const token = localStorage.getItem("access_token");
      
      if (userData && token) {
        try {
          const parsedUser = JSON.parse(userData);
          setUser(parsedUser);
          setIsLoggedIn(true);
          
          // Debug logging
          console.log("Current user data:", parsedUser);
          console.log("User role:", parsedUser.role);
        } catch (error) {
          console.error("Error parsing user data:", error);
          // Clear invalid data
          localStorage.removeItem("user");
          localStorage.removeItem("access_token");
          setUser(null);
          setIsLoggedIn(false);
        }
      } else {
        setUser(null);
        setIsLoggedIn(false);
      }
    };

    checkUser();

    // Listen for storage changes (when user logs in/out in another tab)
    const handleStorageChange = (e) => {
      if (e.key === "user" || e.key === "access_token") {
        checkUser();
      }
    };

    // Listen for custom login event
    const handleUserLogin = (e) => {
      console.log("Header received login event:", e.detail);
      setUser(e.detail);
      setIsLoggedIn(true);
    };

    window.addEventListener("storage", handleStorageChange);
    window.addEventListener("userLogin", handleUserLogin);
    
    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener("userLogin", handleUserLogin);
    };
  }, []);

  const handleSignOut = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("user");
    setUser(null);
    setIsLoggedIn(false);
    navigate("/login");
  };

  const handleAdmin = () => {
    navigate("/admin");
  }

  const isAdmin = user && user.role && user.role.toLowerCase() === 'admin';

  // Debug display
  if (user) {
    console.log("Header - User role:", user.role);
    console.log("Header - Is admin:", isAdmin);
  }

  return (
    <div className="header_container">
      <a href="/"><img src="/logo.png" alt="Logo" className="logo" /> </a>

      {isLoggedIn && (
        <div className="user-section">
          <span className="greeting">
            Hello, <strong>{user.first_name} {user.last_name}</strong>! 
            Your role is <em>{user.role && user.role.toLowerCase() === 'admin' ? 'Admin' : 'Exam Manager'}</em>.
          </span>
          
          {isAdmin && (
            <button className="signout-button" onClick={handleAdmin}>
              Admin Panel
            </button>
          )}
          
          <button className="signout-button" onClick={() => navigate("/my-profile")}>
            My Profile
          </button>
          
          <button className="signout-button" onClick={handleSignOut}>
            Sign Out
          </button>
        </div>
      )}
    </div>
  );
};

export default Header;
